import { useContext } from 'react'

import type { DashboardBridge } from './DashboardBridge'
import { DashboardBridgeContext } from './DashboardBridgeProvider'

export function useDashboardBridge(): DashboardBridge {
  const bridge = useContext(DashboardBridgeContext)

  if (!bridge) {
    throw new Error('useDashboardBridge must be used inside <DashboardBridgeProvider>')
  }

  return bridge
}

/**
 * Non-throwing variant — returns `null` when there is no
 * `<DashboardBridgeProvider>` above. Use this in dashboard ELEMENTS (e.g.
 * DashboardCctv / DashboardVideo) that must still render in isolation (their
 * specs render them without a provider, mirroring the tolerant `useCctvPlayback`).
 * In production every element is inside a provider, so the bridge is present;
 * outside one, bridge-driven features (chatbot capture/control) simply no-op.
 */
export function useDashboardBridgeOptional(): DashboardBridge | null {
  return useContext(DashboardBridgeContext)
}
